import { render, staticRenderFns } from "./PartnerOrder.vue?vue&type=template&id=3369abe4&"
import script from "./PartnerOrder.vue?vue&type=script&lang=js&"
export * from "./PartnerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports